import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { EspaceAdministrationButton } from './EspaceAdministrationButton';
import { withFTPEAccess } from '../components/FTPEAccessGuard';
import { usePageTracking } from '../hooks/usePageTracking';

// Lazy imports pour les pages (performance)
import OscopHomePage from '../pages/OscopHomePage';
import MesConsommations from '../pages/MesConsommations';
import DispositifsBTPPage from '../pages/DispositifsBTPPage';
import VefaTunnelPage from '../pages/VefaTunnelPage';
import ServicesEntreprisesPage from '../pages/ServicesEntreprisesPage';
import FormationPage from '../pages/FormationPage';
import OscopGEPage from '../pages/OscopGEPage';
import ProjetsASoutenirPage from '../pages/ProjetsASoutenirPage';
import FormascopPage from '../pages/FormascopPage';
import LogistiqueMobilitePage from '../pages/LogistiqueMobilitePage';
import AgroVegetalPage from '../pages/AgroVegetalPage';
import BatimentExpertisePage from '../pages/BatimentExpertisePage';
import RegistryVerificationPage from '../pages/RegistryVerificationPage';
import VerifyDomiumPage from '../pages/VerifyDomiumPage';
import NominativeSignPage from '../pages/NominativeSignPage';
import VerifyFacturePlanPage from '../pages/VerifyFacturePlanPage';
import VerifyRegistreFiscalPage from '../pages/VerifyRegistreFiscalPage';
import PropositionSignaturePage from '../pages/PropositionSignaturePage';
import PreviewToProductionRedirect, { PreviewRedirectGuard } from './PreviewToProductionRedirect';
import AdminContentManagement from '../pages/AdminContentManagement';
import AdminActivityBilling from '../pages/AdminActivityBilling';
import AdminSimulatorConfig from '../pages/AdminSimulatorConfig';
import COPPAMGaranties from '../pages/COPPAMGaranties';
import AccompagnementPage from '../pages/AccompagnementPage';
import FOGEDOMPage from '../pages/FOGEDOMPage';
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import ActivitiesCommunityplace from '../pages/ActivitiesCommunityplace';
import SubscribePage from '../pages/SubscribePage';
import DocumentOscopGE from '../pages/DocumentOscopGE';
import MemberDashboard from '../pages/MemberDashboard';
import CooperDashboard from '../pages/CooperDashboard';
import BeneficiaireParticulierDashboard from '../pages/BeneficiaireParticulierDashboard';
import AdminDashboard from '../pages/AdminDashboard';
import CcmiDashboard from '../pages/CcmiDashboard';
import JuristeQueue from '../pages/JuristeQueue';
import LegalcoopDashboard from '../pages/LegalcoopDashboard';
import LegalcoopFinanceDashboard from '../pages/LegalcoopFinanceDashboard';
import SepaMandatesPage from '../pages/SepaMandatesPage';
import ExpertDashboard from '../pages/ExpertDashboard';
import VerifierRecapContributions from '../pages/VerifierRecapContributions';
import DashboardUnified from '../pages/DashboardUnified';
import ExpertInscription from '../pages/ExpertInscription';
import TerritoiresManagement from '../pages/TerritoiresManagement';
import TestTerritoires from '../pages/TestTerritoires';
import AdminGestion from '../pages/AdminGestion';
import AdminLogin from '../pages/AdminLogin';
import CalculateurBATICO from '../pages/CalculateurBATICO';
import PublicSharePage from '../pages/PublicSharePage';
import SepaReturnPage from '../pages/SepaReturnPage';
import SimulateurTarification from '../pages/SimulateurTarification';
import QuiSommesNous from '../pages/QuiSommesNous';
import APropos from '../pages/APropos';
import FonctionnementDispositif from '../pages/FonctionnementDispositif';
import GarantiesPage from '../pages/GarantiesPage';
import QuestionnaireMembre from '../pages/QuestionnaireMembre';
import EngagementsESSPage from '../pages/EngagementsESSPage';
import Actualites from '../pages/Actualites';
import ActualiteDetailPage from '../pages/ActualiteDetailPage';
import PartenairesSponsorsPage from '../pages/PartenairesSponsorsPage';
import FicheSponsorPage from '../pages/FicheSponsorPage';
import DevenirSponsorPage from '../pages/DevenirSponsorPage';
import AdminSponsorsPage from '../pages/AdminSponsorsPage';
import AdminSponsorImpactPage from '../pages/AdminSponsorImpactPage';
import SponsorActivationPage from '../pages/SponsorActivationPage';
import EspaceSponsorPage from '../pages/EspaceSponsorPage';
import AidesSolidaires from '../pages/AidesSolidaires';
import PoliceRcdSolidaire from '../pages/PoliceRcdSolidaire';
import Nouveautes from '../pages/Nouveautes';
import Fogedom from '../pages/Fogedom';
import MentionsLegalesPage from '../pages/MentionsLegalesPage';
import ConditionsGeneralesPage from '../pages/ConditionsGeneralesPage';
import PolitiqueRGPDPage from '../pages/PolitiqueRGPDPage';
import TarifsBatimentPage from '../pages/TarifsBatimentPage';
import MemberResetPassword from '../pages/MemberResetPassword';
import CooperResetPassword from '../pages/CooperResetPassword';
import AdminResetPassword from '../pages/AdminResetPassword';
import SouscriptionWorkflow from '../pages/SouscriptionWorkflow';
import SouscriptionAnnuelleWorkflow from '../pages/SouscriptionAnnuelleWorkflow';
import AvenantWorkflow from '../pages/AvenantWorkflow';
import CoopersAdhesions from '../pages/CoopersAdhesions';
import AchatsDemandesPubliques from '../pages/AchatsDemandesPubliques';
import PaiementSuccess from '../pages/PaiementSuccess';
import PresentationRCDS from '../pages/PresentationRCDS';
import GenerateAttestationRCDS from '../pages/GenerateAttestationRCDS';
import MemberProfile from '../pages/MemberProfile';
import CooperProfile from '../pages/CooperProfile';
import AdminProfile from '../pages/AdminProfile';
import ExpertProfile from '../pages/ExpertProfile';
import ExpertComptableDashboard from '../pages/ExpertComptableDashboard';
import SuperAdminDashboard from '../pages/SuperAdminDashboard';
import AdminTestAccountsPage from '../pages/AdminTestAccountsPage';
import SuperAdminCMSPage from '../pages/SuperAdminCMSPage';
import AdminCreditsPage from '../pages/AdminCreditsPage';
import CMSDashboard from '../pages/CMS/CMSDashboard';
import MetiersDemo from '../pages/MetiersDemo';
import SubscriptionManagement from '../pages/SubscriptionManagement';
import WalletManagement from '../pages/WalletManagement';
import AdminBillingManagement from '../pages/AdminBillingManagement';
import AdminMapWorld from '../pages/AdminMapWorld';
import LogoFogedomPage from '../pages/LogoFogedomPage';
import ContractGenerator from '../pages/ContractGenerator';
import ContractsList from '../pages/ContractsList';
import ContractVerification from '../pages/ContractVerification';
import QRCodeVerification from '../pages/QRCodeVerification';
import ServicesPage from '../pages/ServicesPage';
import AdhesionPage from '../pages/AdhesionPage';
import EtablissementsPage from '../pages/EtablissementsPage';
import GarantiesSolidairesBTPPage from '../pages/GarantiesSolidairesBTPPage';
import InnovationSocialePage from '../pages/InnovationSocialePage';
import PaymentSuccess from '../pages/PaymentSuccess';
import PaymentCancel from '../pages/PaymentCancel';
import ContactPage from '../pages/ContactPage';
import DemandePublique from '../pages/DemandePublique';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import MagicAuth from '../pages/MagicAuth';
import SetPasswordModal from './SetPasswordModal';
import AdminNavigationConfig from '../pages/AdminNavigationConfig';
import AdhesionFTPE from '../pages/AdhesionFTPE';
import AdhesionFTPEWorkflow from '../pages/AdhesionFTPEWorkflow';
import FTPEOutremerPage from '../pages/FTPEOutremerPage';
import FTPEMissionPage from '../pages/FTPEMissionPage';
import FTPEValeursPage from '../pages/FTPEValeursPage';
import FTPEAdhererPage from '../pages/FTPEAdhererPage';
import FTPEGouvernancePage from '../pages/FTPEGouvernancePage';
import FTPEPartenairesPage from '../pages/FTPEPartenairesPage';
import FTPEFAQPage from '../pages/FTPEFAQPage';
import FTPEChartePage from '../pages/FTPEChartePage';

import VerifyRecuESS from '../pages/VerifyRecuESS';
import SimulateurHabitatPage from '../pages/SimulateurHabitatPage';
import SimulateurMasterPage from '../pages/SimulateurMasterPage';
// V38.14 — Simulateur CAP BATI+ CMI
import SimulateurCapBatiPlusCmi from '../pages/SimulateurCapBatiPlusCmi';
import CapBatiPublicQuotePage from '../pages/CapBatiPublicQuotePage';
import DevisCompletionPage from '../pages/DevisCompletionPage';
import DevisConsultationPage from '../pages/DevisConsultationPage';
import SignatureMembrePage from '../pages/SignatureMembrePage';
import PayerEcheancePage from '../pages/PayerEcheancePage';
import AdminNocodePage from '../pages/AdminNocodePage';
import B2BWalletDashboard from '../pages/B2BWalletDashboard';
import ESSPartnersShowcase from '../pages/ESSPartnersShowcase';
import AdminSuiviPrelevementsSEPA from '../pages/AdminSuiviPrelevementsSEPA';
import CoppamAdherentSpace from '../pages/CoppamAdherentSpace';
import CoppamAdminTerritory from '../pages/CoppamAdminTerritory';
import AttestationBlocksAdmin from '../pages/AttestationBlocksAdmin';
import CoppamGroupDashboard from '../pages/CoppamGroupDashboard';
import OffreCOPPAM from '../pages/OffreCOPPAM';
import OffreOSCOP from '../pages/OffreOSCOP';
import OffreFOGEDOM from '../pages/OffreFOGEDOM';
import RegisterESS from '../pages/RegisterESS';
import CreditPurchaseSuccess from '../pages/CreditPurchaseSuccess';
import CreditPurchaseCancel from '../pages/CreditPurchaseCancel';
import VerificationDOSPublic from '../pages/VerificationDOSPublic';
import VerificationDOMIUM from '../pages/VerificationDOMIUM';

import SimulateurDOS from '../components/SimulateurDOS';
import PaymentSuccessPage from '../pages/PaymentSuccessPage';
import PaymentCancelPage from '../pages/PaymentCancelPage';
import GEDStatistiquesPage from '../pages/GEDStatistiquesPage';
import GestionFinanciereDOMIUM from '../components/GestionFinanciereDOMIUM';

// Redirection pour les anciens QR codes
function NavigateToVerifier({ type }) {
  const params = window.location.pathname.split('/').filter(Boolean);
  const id = params[params.length - 1];
  return <Navigate to={`/verifier/${type}/${id}`} replace />;
}

// Route protégée avec gestion du chargement
export function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading, token } = useAuth();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!loading) {
      const timer = setTimeout(() => setIsInitialized(true), 50);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  if (loading || !isInitialized || (token && !user && !loading)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-500 text-sm">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    if (/^\/(admin|member)/.test(window.location.pathname)) {
      sessionStorage.setItem('redirect_after_login', `${window.location.pathname}${window.location.search}`);
    }
    return <Navigate to={window.location.pathname.startsWith('/admin') ? '/admin/login' : '/login'} replace />;
  }
  // V35.65 — Le super_admin (rôle suprême) peut accéder à toutes les
  // routes protégées. Cela évite qu'un clic depuis le dashboard super
  // admin vers une route restreinte à certains rôles ne renvoie
  // l'utilisateur vers la page d'accueil (puis login par cascade).
  const roleAdminAccess = user.custom_role_admin_access && allowedRoles?.includes('admin');
  if (allowedRoles && !allowedRoles.includes(user.role) && user.role !== 'super_admin' && !roleAdminAccess) {
    // Au lieu de renvoyer vers "/" (page d'accueil publique → login),
    // on renvoie vers le dashboard du rôle de l'utilisateur. Reste
    // dans l'app, garde la session, évite la déconnexion observée.
    const dashboardByRole = {
      admin: '/admin/dashboard',
      cooper: '/cooper/dashboard',
      member: '/member/dashboard',
      beneficiaire_pro: '/member/dashboard',
      expert: '/expert/dashboard',
    };
    return <Navigate to={dashboardByRole[user.role] || '/'} replace />;
  }
  return children;
}

// FTPE protected dashboards
const FTPEProtectedCooperDashboard = withFTPEAccess(CooperDashboard);
const FTPEProtectedExpertDashboard = withFTPEAccess(ExpertDashboard);

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

export default function AppRoutes() {
  // V35.2 — Active le tracking analytics sur toutes les pages
  usePageTracking();

  return (
    <>
      <ScrollToTop />
      <PreviewRedirectGuard />
      <SetPasswordModal />
      <EspaceAdministrationButton />
      <Routes>
      {/* Pages publiques O'SCOP */}
      <Route path="/" element={<OscopHomePage />} />
      <Route path="/sepa/return" element={<SepaReturnPage />} />
      <Route path="/verify/domium/:reference" element={<PreviewToProductionRedirect><VerifyDomiumPage /></PreviewToProductionRedirect>} />
      <Route path="/factures-plans/verify/:qrToken" element={<VerifyFacturePlanPage />} />
      <Route path="/v/registre-fiscal/:token" element={<VerifyRegistreFiscalPage />} />
      <Route path="/proposition/signature" element={<PropositionSignaturePage />} />
      <Route path="/sign/nominative/:token" element={<NominativeSignPage />} />
      <Route path="/dispositifs-btp" element={<DispositifsBTPPage />} />
      {/* V37.74 — Tunnel VEFA (programme immobilier) */}
      <Route path="/simulateurs/vefa-tunnel" element={<VefaTunnelPage />} />
      {/* V38.14 — Simulateur CAP BATI+ CMI (constructeur maison individuelle)
          V38.19 — Accès restreint admin/expert/cooper (plus de front office public) */}
      <Route path="/simulateurs/cap-bati-plus-cmi" element={
        <ProtectedRoute allowedRoles={['super_admin', 'admin', 'expert', 'cooper', 'juriste']}>
          <SimulateurCapBatiPlusCmi />
        </ProtectedRoute>
      } />
      {/* V38.24/V38.25 — Page publique constructeur (paiement + signature) */}
      <Route path="/devis-cap-bati/:token" element={<CapBatiPublicQuotePage />} />
      <Route path="/devis/completer/:token" element={<DevisCompletionPage />} />
      <Route path="/devis/consulter/:token" element={<DevisConsultationPage />} />
      <Route path="/signer-dispositif/:token" element={<SignatureMembrePage />} />
      <Route path="/devis/payer/:token" element={<PayerEcheancePage />} />
      <Route path="/souscription/payer/:token" element={<PayerEcheancePage apiBase={`${process.env.REACT_APP_BACKEND_URL}/api/member-invitation/rappel-paiement`} />} />
      <Route path="/services-entreprises" element={<ServicesEntreprisesPage />} />
      <Route path="/formation" element={<FormationPage />} />
      <Route path="/oscop-ge" element={<OscopGEPage />} />
      <Route path="/formascop" element={<FormascopPage />} />
      <Route path="/logistique-mobilite" element={<LogistiqueMobilitePage />} />
      <Route path="/rcds-batico" element={<PresentationRCDS />} />
      <Route path="/projets-a-soutenir" element={<ProjetsASoutenirPage />} />
      <Route path="/agro-vegetal" element={<AgroVegetalPage />} />
      <Route path="/batiment-expertise" element={<BatimentExpertisePage />} />
      <Route path="/documents/oscop-ge" element={<DocumentOscopGE />} />
      <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
      <Route path="/a-propos" element={<APropos />} />
      <Route path="/fonctionnement-dispositif" element={<FonctionnementDispositif />} />
      <Route path="/garanties" element={<GarantiesPage />} />
      <Route path="/engagements-ess" element={<EngagementsESSPage />} />
      <Route path="/actualites" element={<Actualites />} />
      <Route path="/actualites/:slug" element={<ActualiteDetailPage />} />
      <Route path="/partenaires-sponsors" element={<PartenairesSponsorsPage />} />
      <Route path="/partenaires-sponsors/:slug" element={<FicheSponsorPage />} />
      <Route path="/devenir-sponsor" element={<DevenirSponsorPage />} />
      <Route path="/espace-sponsor/activation/:token" element={<SponsorActivationPage />} />
      <Route path="/espace-sponsor" element={<EspaceSponsorPage />} />
      <Route path="/aides-solidaires" element={<AidesSolidaires />} />
      <Route path="/police-rcd-solidaire" element={<PoliceRcdSolidaire />} />
      <Route path="/nouveautes" element={<Nouveautes />} />
      <Route path="/fogedom" element={<FOGEDOMPage />} />
      <Route path="/fogedom/presentation" element={<Fogedom />} />
      <Route path="/fogedom/accompagnement" element={<AccompagnementPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/adhesion" element={<AdhesionPage />} />
      <Route path="/etablissements" element={<EtablissementsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/demande/deposer" element={<DemandePublique />} />
      <Route path="/presentation-rcds" element={<PresentationRCDS />} />
      <Route path="/garanties/coppam" element={<COPPAMGaranties />} />
      <Route path="/garanties-solidaires-btp" element={<GarantiesSolidairesBTPPage />} />
      <Route path="/innovation-sociale" element={<InnovationSocialePage />} />
      <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
      <Route path="/conditions-generales" element={<ConditionsGeneralesPage />} />
      <Route path="/politique-rgpd" element={<PolitiqueRGPDPage />} />
      <Route path="/carte-monde" element={<ProtectedRoute allowedRoles={['super_admin']}><AdminMapWorld /></ProtectedRoute>} />
      <Route path="/simulateur-habitat" element={<SimulateurHabitatPage />} />
      <Route path="/simulateur-master" element={<SimulateurMasterPage />} />
      <Route path="/demo-metiers" element={<MetiersDemo />} />
      <Route path="/logo-fogedom" element={<LogoFogedomPage />} />
      <Route path="/test-territoires" element={<TestTerritoires />} />
      <Route path="/simulateur-dos" element={
        <div className="min-h-screen bg-gray-50 py-8 px-4">
          <div className="max-w-7xl mx-auto"><SimulateurDOS userRole="public" defaultMode="subscription" /></div>
        </div>
      } />
      <Route path="/admin-nocode" element={<AdminNocodePage />} />
      <Route path="/admin/attestation-blocks" element={<ProtectedRoute allowedRoles={['super_admin', 'admin']}><AttestationBlocksAdmin /></ProtectedRoute>} />
      <Route path="/b2b-wallet" element={<B2BWalletDashboard />} />
      <Route path="/partners/ess-odd-aligned" element={<ESSPartnersShowcase />} />

      {/* FTPE Outremer */}
      <Route path="/ftpe-outremer" element={<FTPEOutremerPage />} />
      <Route path="/ftpe-outremer/mission" element={<FTPEMissionPage />} />
      <Route path="/ftpe-outremer/valeurs" element={<FTPEValeursPage />} />
      <Route path="/ftpe-outremer/pourquoi-adherer" element={<FTPEAdhererPage />} />
      <Route path="/ftpe-outremer/gouvernance" element={<FTPEGouvernancePage />} />
      <Route path="/ftpe-outremer/partenaires" element={<FTPEPartenairesPage />} />
      <Route path="/ftpe-outremer/faq" element={<FTPEFAQPage />} />
      <Route path="/ftpe-outremer/charte" element={<FTPEChartePage />} />

      {/* COPPAM Multi-Territoires */}
      <Route path="/coppam" element={<CoppamAdherentSpace />} />
      <Route path="/coppam/adherent" element={<CoppamAdherentSpace />} />
      <Route path="/coppam/admin-territoire" element={<CoppamAdminTerritory />} />
      <Route path="/coppam/groupe" element={<CoppamGroupDashboard />} />
      <Route path="/offre-coppam" element={<OffreCOPPAM />} />
      <Route path="/offre-oscop" element={<OffreOSCOP />} />
      <Route path="/offre-fogedom" element={<OffreFOGEDOM />} />
      <Route path="/inscription-ess" element={<RegisterESS />} />

      {/* Auth */}
      <Route path="/questionnaire-membre/:token" element={<QuestionnaireMembre />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth/magic" element={<MagicAuth />} />
      <Route path="/reset-password/member" element={<MemberResetPassword />} />
      <Route path="/reset-password/cooper" element={<CooperResetPassword />} />
      <Route path="/reset-password/admin" element={<AdminResetPassword />} />
      <Route path="/expert/inscription" element={<ExpertInscription />} />

      {/* Payment */}
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/credits/success" element={<CreditPurchaseSuccess />} />
      <Route path="/credits/cancel" element={<CreditPurchaseCancel />} />
      <Route path="/mes-consommations" element={<MesConsommations />} />
      <Route path="/paiement/success" element={<PaymentSuccessPage />} />
      <Route path="/paiement/cancel" element={<PaymentCancelPage />} />

      {/* Verification publique */}
      <Route path="/verifier/:documentType/:documentId" element={<PreviewToProductionRedirect><QRCodeVerification /></PreviewToProductionRedirect>} />
      <Route path="/verifier" element={<PreviewToProductionRedirect><QRCodeVerification /></PreviewToProductionRedirect>} />
      <Route path="/api/verifier/:documentType/:documentId" element={<PreviewToProductionRedirect><QRCodeVerification /></PreviewToProductionRedirect>} />
      <Route path="/verification-recap/:recapId" element={<VerifierRecapContributions />} />
      <Route path="/verifier/recu-ess/:recuId" element={<PreviewToProductionRedirect><VerifyRecuESS /></PreviewToProductionRedirect>} />
      <Route path="/verify-document/:documentId" element={<PreviewToProductionRedirect><NavigateToVerifier type="rcds" /></PreviewToProductionRedirect>} />
      <Route path="/verify-document" element={<PreviewToProductionRedirect><ContractVerification /></PreviewToProductionRedirect>} />
      <Route path="/verify/ftpe/:adhesionId" element={<PreviewToProductionRedirect><NavigateToVerifier type="ftpe" /></PreviewToProductionRedirect>} />
      <Route path="/verify/rcds/:documentId" element={<PreviewToProductionRedirect><NavigateToVerifier type="rcds" /></PreviewToProductionRedirect>} />
      <Route path="/verifier/recu-ftpe/:recuId" element={<PreviewToProductionRedirect><NavigateToVerifier type="ftpe" /></PreviewToProductionRedirect>} />
      {/* Redirections pour anciennes URLs de QR codes (generees avant correction) */}
      <Route path="/api/attestation/verifier/:id" element={<PreviewToProductionRedirect><NavigateToVerifier type="attestation" /></PreviewToProductionRedirect>} />
      <Route path="/api/conditions-generales/verifier/:id" element={<PreviewToProductionRedirect><NavigateToVerifier type="conditions-generales" /></PreviewToProductionRedirect>} />
      <Route path="/api/proposition/verifier/:id" element={<PreviewToProductionRedirect><NavigateToVerifier type="proposition" /></PreviewToProductionRedirect>} />
      <Route path="/api/conditions-particulieres/verifier/:id" element={<PreviewToProductionRedirect><NavigateToVerifier type="cp" /></PreviewToProductionRedirect>} />
      <Route path="/dos/verify/:attestationId" element={<PreviewToProductionRedirect><VerificationDOSPublic /></PreviewToProductionRedirect>} />
      <Route path="/dos/verify" element={<PreviewToProductionRedirect><VerificationDOSPublic /></PreviewToProductionRedirect>} />
      <Route path="/verify/domium/:reference" element={<PreviewToProductionRedirect><VerificationDOMIUM /></PreviewToProductionRedirect>} />
      <Route path="/verify/domium" element={<PreviewToProductionRedirect><VerificationDOMIUM /></PreviewToProductionRedirect>} />
      <Route path="/verify/registry/:registryId" element={<PreviewToProductionRedirect><RegistryVerificationPage /></PreviewToProductionRedirect>} />

      {/* RGPD — Page publique de partage à token signé (V35.24) */}
      <Route path="/share/:token" element={<PublicSharePage />} />

      {/* Routes protégées - Communityplace & Simulateurs */}
      <Route path="/communityplace" element={<ProtectedRoute allowedRoles={['member', 'cooper', 'admin', 'super_admin', 'expert']}><ActivitiesCommunityplace /></ProtectedRoute>} />
      {/* Alias de compatibilité — ancien chemin /marketplace */}
      <Route path="/marketplace" element={<Navigate to="/communityplace" replace />} />
      <Route path="/subscribe" element={<ProtectedRoute allowedRoles={['member', 'cooper', 'admin', 'super_admin', 'expert']}><SubscribePage /></ProtectedRoute>} />
      <Route path="/tarifs-batiment" element={<ProtectedRoute allowedRoles={['member', 'cooper', 'admin', 'super_admin', 'expert']}><TarifsBatimentPage /></ProtectedRoute>} />
      <Route path="/calculateur-batico" element={<ProtectedRoute allowedRoles={['cooper', 'super_admin', 'member', 'beneficiaire_pro']}><CalculateurBATICO /></ProtectedRoute>} />
      <Route path="/tarificateur/batico" element={<ProtectedRoute allowedRoles={['cooper', 'super_admin', 'member', 'beneficiaire_pro']}><CalculateurBATICO /></ProtectedRoute>} />
      <Route path="/simulateur-tarification" element={<ProtectedRoute allowedRoles={['member', 'cooper', 'admin', 'super_admin', 'expert']}><SimulateurTarification /></ProtectedRoute>} />
      <Route path="/generer-attestation-rcds" element={<ProtectedRoute allowedRoles={['admin', 'super_admin', 'cooper']}><GenerateAttestationRCDS /></ProtectedRoute>} />

      {/* FTPE Adhesion */}
      <Route path="/adhesion-ftpe" element={<ProtectedRoute allowedRoles={['member', 'cooper', 'expert']}><AdhesionFTPE /></ProtectedRoute>} />
      <Route path="/adhesion-success" element={<ProtectedRoute allowedRoles={['member', 'cooper', 'expert']}><AdhesionFTPE /></ProtectedRoute>} />
      <Route path="/adhesion-ftpe-workflow" element={<ProtectedRoute allowedRoles={['member', 'cooper', 'expert', 'super_admin', 'admin']}><AdhesionFTPEWorkflow /></ProtectedRoute>} />

      {/* Member routes */}
      <Route path="/member/souscription" element={<ProtectedRoute allowedRoles={['member', 'beneficiaire_pro', 'super_admin', 'admin', 'cooper']}><SouscriptionWorkflow /></ProtectedRoute>} />
      <Route path="/member/profile" element={<ProtectedRoute allowedRoles={['member', 'beneficiaire_pro']}><MemberProfile /></ProtectedRoute>} />
      <Route path="/member/contracts" element={<ProtectedRoute><ContractsList /></ProtectedRoute>} />
      <Route path="/member/contracts/new" element={<ProtectedRoute allowedRoles={['admin', 'super_admin', 'cooper']}><ContractGenerator /></ProtectedRoute>} />
      <Route path="/member/*" element={<ProtectedRoute allowedRoles={['member', 'beneficiaire_pro']}><MemberDashboard /></ProtectedRoute>} />
      <Route path="/subscription-management" element={<ProtectedRoute allowedRoles={['member', 'cooper', 'beneficiaire_pro']}><SubscriptionManagement /></ProtectedRoute>} />
      <Route path="/wallet-management" element={<ProtectedRoute allowedRoles={['member', 'cooper', 'beneficiaire_pro']}><WalletManagement /></ProtectedRoute>} />
      <Route path="/beneficiaire-particulier/*" element={<ProtectedRoute allowedRoles={['beneficiaire_particulier']}><BeneficiaireParticulierDashboard /></ProtectedRoute>} />

      {/* Cooper routes */}
      <Route path="/cooper/souscription-annuelle" element={<ProtectedRoute allowedRoles={['cooper', 'super_admin', 'admin', 'member']}><SouscriptionAnnuelleWorkflow /></ProtectedRoute>} />
      <Route path="/souscription-annuelle" element={<ProtectedRoute allowedRoles={['cooper', 'super_admin', 'admin', 'member', 'expert']}><SouscriptionAnnuelleWorkflow /></ProtectedRoute>} />
      <Route path="/cooper/avenant-workflow" element={<ProtectedRoute allowedRoles={['cooper', 'super_admin', 'member']}><AvenantWorkflow /></ProtectedRoute>} />
      <Route path="/coopers/adhesions" element={<ProtectedRoute allowedRoles={['cooper', 'super_admin']}><CoopersAdhesions /></ProtectedRoute>} />
      <Route path="/cooper/achats-demandes" element={<ProtectedRoute allowedRoles={['cooper']}><AchatsDemandesPubliques /></ProtectedRoute>} />
      <Route path="/achats-demandes-publiques" element={<ProtectedRoute allowedRoles={['cooper']}><AchatsDemandesPubliques /></ProtectedRoute>} />
      <Route path="/paiement-success" element={<ProtectedRoute allowedRoles={['cooper']}><PaiementSuccess /></ProtectedRoute>} />
      <Route path="/paiement-retour" element={<ProtectedRoute allowedRoles={['cooper']}><PaiementSuccess /></ProtectedRoute>} />
      <Route path="/cooper/profile" element={<ProtectedRoute allowedRoles={['cooper']}><CooperProfile /></ProtectedRoute>} />
      <Route path="/cooper/*" element={<ProtectedRoute allowedRoles={['cooper']}><FTPEProtectedCooperDashboard /></ProtectedRoute>} />

      {/* Expert routes */}
      <Route path="/expert-comptable" element={<ProtectedRoute allowedRoles={['expert_comptable']}><ExpertComptableDashboard /></ProtectedRoute>} />
      <Route path="/expert/profile" element={<ProtectedRoute allowedRoles={['expert']}><ExpertProfile /></ProtectedRoute>} />
      <Route path="/expert/*" element={<ProtectedRoute allowedRoles={['expert']}><FTPEProtectedExpertDashboard /></ProtectedRoute>} />

      {/* Admin routes */}
      <Route path="/admin/content-management" element={<ProtectedRoute allowedRoles={['super_admin']}><AdminContentManagement /></ProtectedRoute>} />
      <Route path="/admin/activity-billing" element={<ProtectedRoute allowedRoles={['super_admin']}><AdminActivityBilling /></ProtectedRoute>} />
      <Route path="/admin/simulator-config" element={<ProtectedRoute allowedRoles={['super_admin']}><AdminSimulatorConfig /></ProtectedRoute>} />
      <Route path="/admin/billing-management" element={<ProtectedRoute allowedRoles={['super_admin', 'admin']}><AdminBillingManagement /></ProtectedRoute>} />
      <Route path="/admin/carte-monde" element={<ProtectedRoute allowedRoles={['super_admin']}><AdminMapWorld /></ProtectedRoute>} />
      <Route path="/admin/profile" element={<ProtectedRoute allowedRoles={['admin', 'super_admin']}><AdminProfile /></ProtectedRoute>} />
      <Route path="/admin/super-dashboard" element={<ProtectedRoute allowedRoles={['super_admin']}><SuperAdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/navigation-config" element={<ProtectedRoute allowedRoles={['super_admin']}><AdminNavigationConfig /></ProtectedRoute>} />
      <Route path="/admin/comptes-test" element={<ProtectedRoute allowedRoles={['super_admin']}><AdminTestAccountsPage /></ProtectedRoute>} />
      <Route path="/admin/credits" element={<ProtectedRoute allowedRoles={['super_admin']}><AdminCreditsPage /></ProtectedRoute>} />
      <Route path="/admin/super-cms" element={<ProtectedRoute allowedRoles={['super_admin']}><SuperAdminCMSPage /></ProtectedRoute>} />
      <Route path="/admin/cms" element={<ProtectedRoute allowedRoles={['super_admin']}><CMSDashboard /></ProtectedRoute>} />
      <Route path="/admin/sponsors" element={<ProtectedRoute allowedRoles={['super_admin']}><AdminSponsorsPage /></ProtectedRoute>} />
      <Route path="/admin/sponsors/impact" element={<ProtectedRoute allowedRoles={['super_admin', 'admin']}><AdminSponsorImpactPage /></ProtectedRoute>} />
      <Route path="/admin/gestion" element={<ProtectedRoute allowedRoles={['admin', 'super_admin']}><AdminGestion /></ProtectedRoute>} />
      <Route path="/admin/prelevements-sepa" element={<ProtectedRoute allowedRoles={['admin', 'super_admin']}><AdminSuiviPrelevementsSEPA /></ProtectedRoute>} />
      <Route path="/admin/territoires" element={<ProtectedRoute allowedRoles={['super_admin']}><TerritoiresManagement /></ProtectedRoute>} />
      <Route path="/admin/ged-statistiques" element={<ProtectedRoute allowedRoles={['admin', 'super_admin']}><GEDStatistiquesPage /></ProtectedRoute>} />
      <Route path="/admin/ccmi-dashboard" element={<ProtectedRoute allowedRoles={['admin', 'super_admin']}><CcmiDashboard /></ProtectedRoute>} />
      <Route path="/admin/juriste/queue" element={<ProtectedRoute allowedRoles={['admin', 'super_admin', 'juriste']}><JuristeQueue /></ProtectedRoute>} />
      <Route path="/admin/legalcoop" element={<ProtectedRoute allowedRoles={['admin', 'super_admin', 'juriste']}><LegalcoopDashboard /></ProtectedRoute>} />
      <Route path="/admin/legalcoop/finance" element={<ProtectedRoute allowedRoles={['admin', 'super_admin']}><LegalcoopFinanceDashboard /></ProtectedRoute>} />
      <Route path="/super-admin/sepa-mandates" element={<ProtectedRoute allowedRoles={['admin', 'super_admin']}><SepaMandatesPage /></ProtectedRoute>} />
      <Route path="/dashboard-unified" element={<ProtectedRoute allowedRoles={['admin', 'super_admin', 'cooper']}><DashboardUnified /></ProtectedRoute>} />
      <Route path="/debug-domium" element={
        <ProtectedRoute allowedRoles={['super_admin']}>
          <div className="min-h-screen bg-gray-50 py-8 px-4">
            <div className="max-w-7xl mx-auto"><GestionFinanciereDOMIUM /></div>
          </div>
        </ProtectedRoute>
      } />
      <Route path="/admin/*" element={<ProtectedRoute allowedRoles={['admin', 'super_admin']}><AdminDashboard /></ProtectedRoute>} />
    </Routes>
    </>
  );
}
